goog.module('yext.entity.fields.CompoundAddress');
goog.module.declareLegacyNamespace();

const dom = goog.require('goog.dom');
const dataset = goog.require('goog.dom.dataset');

const yext = goog.require('yext');
const ServiceArea = goog.require('yext.entity.fields.ServiceArea');
const ServiceAreaEdit = goog.require('yext.entity.fields.ServiceAreaEdit');
const Address = goog.require('yext.location.Address');

/**
 * Service area field (sub field of address compound field)
 *
 * @author MattJS (matt@yext.com)
 */
const CompoundAddress = class {
  /**
   * @param {!jQuery} $ctx Element context for the field
   */
  constructor($ctx) {
    this.$ctx = $ctx;
    this.$edit = $ctx.find('.js-compound-address-edit').addBack().filter('.js-compound-address-edit');
    this.$addressHidden = this.$edit.find('.js-hide-address-checkbox');
    this.$fieldValue = $ctx.find('.js-field-value');

    this.address = this.extractAddress();
    this.serviceArea = new ServiceArea(
      this.$ctx.find('.js-service-area-edit'));
    this.addressHidden = this.$addressHidden.is(':checked');
    this.timestamp = this.$edit.data('timestamp');

    this.renderServiceAreaPlaces();

    this.storeValue();
    this.setFieldValue();
    this.bind();
  }

  renderServiceAreaPlaces() {
    const editView = dom.getElementByClass('js-service_area_places_react_edit');
    if (editView) {
      const data = JSON.parse(dom.dataset.get(editView, 'serviceareaplaces'));
      this.renderServiceAreaEdit(editView, data);
    }
  }

  /**
   * Renders the service area places edit field
   */
  renderServiceAreaEdit(view, data) {
    const places = data.places || [];
    const placesTypes = data.placesTypes || [];

    this.serviceAreaPlaces = {places: places};
    const props = {
      serviceAreaPlaces: places,
      serviceAreaPlaceTypes: placesTypes,
      onChange: newPlaces => {
        this.serviceAreaPlaces.places = newPlaces;
        this.onUpdate();
      },
    };
    ReactDOM.render(React.createElement(ServiceAreaEdit, props), view);
  }

  /**
   * @return {Address} Extract the previously bound address from the DOM
   */
  extractAddress() {
    return this.$ctx.find('.js-entity-address-field').data('address');
  }

  /**
   * Bind the subfields
   */
  bind() {
    $(this.address).on('updated', () => {
      this.onUpdate();
    });

    $(this.serviceArea).on('updated', () => {
      this.onUpdate();
    });

    $(this.address).on('submitField', () => {
      this.emitSubmitField();
    });

    this.$addressHidden.on('click change', () => {
      let checked = this.$addressHidden.is(':checked');
      if (this.addressHidden != checked) {
        this.addressHidden = checked;
        this.onUpdate();
      }
    });
  }

  /**
   * Set the hidden input with the field's value in a JSON format
   */
  setFieldValue() {
    this.$fieldValue.val(yext.JSON.stringify(this.getData()));
  }

  /**
   * Store the value of the subfields in their current state
   */
  storeValue() {
    this.address.storeValue();
    this.serviceArea.storeValue();
    this.storedAddressHidden = this.addressHidden;
  }

  /**
   * @return {!Object} Field data, keyed by strings
   */
  getData() {
    return {
      'address': this.address.getData(),
      'serviceArea': this.serviceArea.getData(),
      'serviceAreaPlaces': this.serviceAreaPlaces,
      'addressHidden': this.addressHidden,
      'timestamp': this.timestamp,
    };
  }

  /**
   * @return {!Object} used when updating address field in Yahoo Free Basic account.
   *
   * The returned object matches BasicEntityVerification.java 'getEndorsement' method's address case.
   * Please use getData() method for retrieving compound address information.
   */
  getDataForEntityVerification() {
    const address = this.address.getData() || {};
    return {
      'address.address': address.line1 && address.line1.value,
      'address.address2': address.line2 && address.line2.value,
      'address.city': address.city && address.city.value,
      'address.state': address.region && address.region.value,
      'address.sublocality': address.sublocality && address.sublocality.value,
      'address.postalCode': address.postalCode && address.postalCode.value,
      'address.country': address.countryCode,
    };
  }

  /**
   * Triggered when the address field is updated
   */
  onUpdate() {
    this.setFieldValue();
    this.render();
    this.emitUpdate();
  }

  /**
   * Render an UI changes related to the field value updating
   */
  render() {
    this.$addressHidden.prop('checked', this.addressHidden).trigger('change');
  }

  /**
   * Emit an event when the field is updated
   */
  emitUpdate() {
    $(this).trigger('updated');
  }

  /**
   * Emit an submit field message for when this is triggered by abnormal means.
   * Ex. The user accepting a bad address
   */
  emitSubmitField() {
    $(this).trigger('submitField');
  }

  /**
   * Set the field's value to that of the provided object
   * @param {!Object} field Plain object version of this field
   */
  set(field) {
    this.address.set(field['address']);
    this.serviceArea.set(field['serviceArea']);
    this.addressHidden = field['addressHidden'];
    this.timestamp = field['timestamp'];
    this.triggerMapMarkerUpdate(field);
    this.render();
  }

  /**
   * Send a message for the map marker field
   * @param {!Object} field
   */
  triggerMapMarkerUpdate(field) {
    $('.js-map-marker').trigger('entityAddressUpdated', field['address']);
  }

  /**
   * Reset the value of this field to a stored state
   */
  reset() {
    this.address.reset();
    this.serviceArea.reset();
    this.addressHidden = this.storedAddressHidden;
    this.render();
  }

  /**
   * Get the display value for the compound Address field
   */
  getDisplayValue() {
    var html = '';
    if (!this.address.isEmpty()) {
      html += this.address.getDisplayValue();
    }
    if (!this.serviceArea.isEmpty()) {
      html += this.serviceArea.getDisplayValue();
    }
    return html;
  }
};

exports = CompoundAddress;
